
export default [
  {
    "ref": "jane-doe",
    "name": "Jane Doe",
    "avatar": "https://randomuser.me/api/portraits/women/11.jpg",
    "content": "",
    "_meta": {
      "filePath": "authors/jane-doe.mdx",
      "fileName": "jane-doe.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/jane-doe"
    }
  },
  {
    "ref": "jon-doe",
    "name": "Jon Doe",
    "avatar": "https://randomuser.me/api/portraits/men/81.jpg",
    "content": "",
    "_meta": {
      "filePath": "authors/jon-doe.mdx",
      "fileName": "jon-doe.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/jon-doe"
    }
  }
]